/**
 * Bandeau de la fiche cours, allégé (SPEC FC1, R1) : retour au planning, kicker « MARQUE · STUDIO »,
 * nom du cours (et playlist si Mindbody en donne une). Date, horaire, adresse et coach sont dans le
 * panneau « Votre réservation ».
 */
import { useBackToPlanning } from '../useBackToPlanning';
import { Icon } from './Icon';

export function Hero({ kicker, title, subtitle }: { kicker?: string; title: string; subtitle?: string | null }) {
  const back = useBackToPlanning();
  return (
    <header className="mmv2-class-hero">
      <button type="button" className="mmv2-class-hero__back" onClick={back}>
        <Icon name="left" size={14} />
        Retour au planning
      </button>
      {kicker ? <span className="mmv2-kicker mmv2-class-hero__kicker">{kicker}</span> : null}
      <h1 className="mmv2-h1 mmv2-class-hero__title">{title}</h1>
      {subtitle ? <p className="mmv2-class-hero__subtitle">{subtitle}</p> : null}
    </header>
  );
}
